import { gql } from '@apollo/client';

import type { AutoInsuredLength } from '../../types/auto_insured_length.enum';

import type { User } from './user.fragment';
import { BASE_USER_AND_QUOTE_FRAGMENT } from './user.fragment';

/**
 * This query returns user signed up using partner API.
 */
export const SET_PARTNER_USER_API_MUTATION = gql`
  mutation SetPartnerAPIUser($input: SetPartnerAPIUserInput!) {
    setPartnerAPIUser(input: $input) {
      id,
      name,
      phone,
      user {
          ${BASE_USER_AND_QUOTE_FRAGMENT}
      }
      icvQuestions {
        partnerSignup
        isHomeowner
        homeOwnership
        isAutoInsured
        autoInsuredLength
        claims
        violations
        state
        ymms {
          year
          make
          model
        }
        averageCarPolicyPriceByState
      }
    }
  }
`;

export interface SetPartnerAPIUserMutationData {
  data: {
    setPartnerAPIUser: {
      id: string;
      name: string;
      phone: string;
      user: User;
      icvQuestions?: {
        partnerSignup?: boolean;
        isHomeowner?: boolean;
        homeOwnership?: string;
        isAutoInsured?: boolean;
        autoInsuredLength?: AutoInsuredLength;
        claims?: boolean;
        violations?: boolean;
        state?: string;
        ymms?: { year: number; make: string; model: string }[];
        averageCarPolicyPriceByState?: number;
      };
    };
  };
  // Jerry cookie value grabbed from response header.
  // This is set through custom link.
  jerry: string;
  jerryauth: string;
}

export interface SetPartnerAPIUserInput {
  input: {
    utoken: string;
    ptoken: string;
  };
}

export const CREATE_PARTNER_USER_AND_QUOTE_MUTATION = gql`
  mutation CreatePartnerUserAndQuote($pToken: String!, $clickID: String) {
    createPartnerUserAndQuote(pToken: $pToken, clickID: $clickID) {
      id
      name
    }
  }
`;

export interface CreatePartnerUserAndQuoteInput {
  pToken: string;
  clickID: string;
}

export interface CreatePartnerUserAndQuoteData {
  errors?: { message: string }[];
  createPartnerUserAndQuote: {
    id: string;
    name: string;
  };
  // Prefill quoting ABTest variation cookie value grabbed from response header.
  // This is set through custom link.
  prefillQuotingVariation?: string;
}
